<div class="spinner-background" [style.margin-top.px]="marginTop || 88">
  <mat-spinner [diameter]="36" strokeWidth="2"></mat-spinner>
</div>
<span class="loading-results">{{ text || 'Loading Results...' }}</span>
